import api from './api';

const orderService = {
  /**
   * Crear un nuevo pedido
   */
  async create(orderData) {
    try {
      const response = await api.post('/orders', orderData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear el pedido'
      };
    }
  },

  /**
   * Obtener mis pedidos
   */
  async getMyOrders(params = {}) {
    try {
      const response = await api.get('/orders/my-orders', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener pedidos'
      };
    }
  },

  /**
   * Obtener pedidos pendientes (vendedor/admin)
   */
  async getPending(params = {}) {
    try {
      const response = await api.get('/orders/pending', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener pedidos pendientes'
      };
    }
  },

  /**
   * Obtener todos los pedidos (vendedor/admin)
   */
  async getAll(params = {}) {
    try {
      const response = await api.get('/orders/all', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener pedidos'
      };
    }
  },

  /**
   * Obtener un pedido por ID
   */
  async getById(id) {
    try {
      const response = await api.get(`/orders/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener pedido'
      };
    }
  },

  /**
   * Cancelar pedido (cliente)
   */
  async cancel(id) {
    try {
      const response = await api.delete(`/orders/${id}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cancelar pedido'
      };
    }
  },

  /**
   * Actualizar estado (vendedor/admin)
   */
  async updateStatus(id, statusData) {
    try {
      const response = await api.put(`/orders/${id}/status`, statusData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar estado'
      };
    }
  },

  /**
   * Aprobar pedido (vendedor/admin)
   */
  async approve(id, approvalData) {
    try {
      const response = await api.post(`/orders/${id}/approve`, approvalData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al aprobar pedido'
      };
    }
  },

  /**
   * Rechazar pedido (vendedor/admin)
   */
  async reject(id, rejectionData) {
    try {
      const response = await api.post(`/orders/${id}/reject`, rejectionData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al rechazar pedido'
      };
    }
  },

  /**
   * Modificar items del pedido (vendedor/admin)
   */
  async updateItems(id, itemsData) {
    try {
      const response = await api.put(`/orders/${id}/items`, itemsData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar items'
      };
    }
  },

  /**
   * Obtener estadísticas de pedidos (vendedor/admin)
   */
  async getStats() {
    try {
      const response = await api.get('/orders/stats');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener estadísticas'
      };
    }
  }
};

export default orderService;

